// Removed Svelte store import - now accepts callback for map interactions

function reverseObject(obj: any) {
  const reversedObj: any = {}

  // Loop through the keys of the original object
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      reversedObj[obj[key]] = key
    }
  }

  return reversedObj
}

export const removeEmojis = (str: string) => {
  return str.replace(/[^a-zA-Z]/g, '').trim()
}

const country_convert: any = {
  AF: 'AFG',
  AL: 'ALB',
  DZ: 'DZA',
  AS: 'ASM',
  AD: 'AND',
  AO: 'AGO',
  AI: 'AIA',
  AQ: 'ATA',
  AG: 'ATG',
  AR: 'ARG',
  AM: 'ARM',
  AW: 'ABW',
  AU: 'AUS',
  AT: 'AUT',
  AZ: 'AZE',
  BS: 'BHS',
  BH: 'BHR',
  BD: 'BGD',
  BB: 'BRB',
  BY: 'BLR',
  BE: 'BEL',
  BZ: 'BLZ',
  BJ: 'BEN',
  BM: 'BMU',
  BT: 'BTN',
  BO: 'BOL',
  BQ: 'BES',
  BA: 'BIH',
  BW: 'BWA',
  BV: 'BVT',
  BR: 'BRA',
  IO: 'IOT',
  BN: 'BRN',
  BG: 'BGR',
  BF: 'BFA',
  BI: 'BDI',
  CV: 'CPV',
  KH: 'KHM',
  CM: 'CMR',
  CA: 'CAN',
  KY: 'CYM',
  CF: 'CAF',
  TD: 'TCD',
  CL: 'CHL',
  CN: 'CHN',
  CX: 'CXR',
  CC: 'CCK',
  CO: 'COL',
  KM: 'COM',
  CD: 'COD',
  CG: 'COG',
  CK: 'COK',
  CR: 'CRI',
  HR: 'HRV',
  CU: 'CUB',
  CW: 'CUW',
  CY: 'CYP',
  CZ: 'CZE',
  CI: 'CIV',
  DK: 'DNK',
  DJ: 'DJI',
  DM: 'DMA',
  DO: 'DOM',
  EC: 'ECU',
  EG: 'EGY',
  SV: 'SLV',
  GQ: 'GNQ',
  ER: 'ERI',
  EE: 'EST',
  SZ: 'SWZ',
  ET: 'ETH',
  FK: 'FLK',
  FO: 'FRO',
  FJ: 'FJI',
  FI: 'FIN',
  FR: 'FRA',
  GF: 'GUF',
  PF: 'PYF',
  TF: 'ATF',
  GA: 'GAB',
  GM: 'GMB',
  GE: 'GEO',
  DE: 'DEU',
  GH: 'GHA',
  GI: 'GIB',
  GR: 'GRC',
  GL: 'GRL',
  GD: 'GRD',
  GP: 'GLP',
  GU: 'GUM',
  GT: 'GTM',
  GG: 'GGY',
  GN: 'GIN',
  GW: 'GNB',
  GY: 'GUY',
  HT: 'HTI',
  HM: 'HMD',
  VA: 'VAT',
  HN: 'HND',
  HK: 'HKG',
  HU: 'HUN',
  IS: 'ISL',
  IN: 'IND',
  ID: 'IDN',
  IR: 'IRN',
  IQ: 'IRQ',
  IE: 'IRL',
  IM: 'IMN',
  IL: 'ISR',
  IT: 'ITA',
  JM: 'JAM',
  JP: 'JPN',
  JE: 'JEY',
  JO: 'JOR',
  KZ: 'KAZ',
  KE: 'KEN',
  KI: 'KIR',
  KP: 'PRK',
  KR: 'KOR',
  KW: 'KWT',
  KG: 'KGZ',
  LA: 'LAO',
  LV: 'LVA',
  LB: 'LBN',
  LS: 'LSO',
  LR: 'LBR',
  LY: 'LBY',
  LI: 'LIE',
  LT: 'LTU',
  LU: 'LUX',
  MO: 'MAC',
  MG: 'MDG',
  MW: 'MWI',
  MY: 'MYS',
  MV: 'MDV',
  ML: 'MLI',
  MT: 'MLT',
  MH: 'MHL',
  MQ: 'MTQ',
  MR: 'MRT',
  MU: 'MUS',
  YT: 'MYT',
  MX: 'MEX',
  FM: 'FSM',
  MD: 'MDA',
  MC: 'MCO',
  MN: 'MNG',
  ME: 'MNE',
  MS: 'MSR',
  MA: 'MAR',
  MZ: 'MOZ',
  MM: 'MMR',
  NA: 'NAM',
  NR: 'NRU',
  NP: 'NPL',
  NL: 'NLD',
  NC: 'NCL',
  NZ: 'NZL',
  NI: 'NIC',
  NE: 'NER',
  NG: 'NGA',
  NU: 'NIU',
  NF: 'NFK',
  MK: 'MKD',
  MP: 'MNP',
  NO: 'NOR',
  OM: 'OMN',
  PK: 'PAK',
  PW: 'PLW',
  PS: 'PSE',
  PA: 'PAN',
  PG: 'PNG',
  PY: 'PRY',
  PE: 'PER',
  PH: 'PHL',
  PN: 'PCN',
  PL: 'POL',
  PT: 'PRT',
  PR: 'PRI',
  QA: 'QAT',
  RO: 'ROU',
  RU: 'RUS',
  RW: 'RWA',
  RE: 'REU',
  BL: 'BLM',
  SH: 'SHN',
  KN: 'KNA',
  LC: 'LCA',
  MF: 'MAF',
  PM: 'SPM',
  VC: 'VCT',
  WS: 'WSM',
  SM: 'SMR',
  ST: 'STP',
  SA: 'SAU',
  SN: 'SEN',
  RS: 'SRB',
  SC: 'SYC',
  SL: 'SLE',
  SG: 'SGP',
  SX: 'SXM',
  SK: 'SVK',
  SI: 'SVN',
  SB: 'SLB',
  SO: 'SOM',
  ZA: 'ZAF',
  GS: 'SGS',
  SS: 'SSD',
  ES: 'ESP',
  LK: 'LKA',
  SD: 'SDN',
  SR: 'SUR',
  SJ: 'SJM',
  SE: 'SWE',
  CH: 'CHE',
  SY: 'SYR',
  TW: 'TWN',
  TJ: 'TJK',
  TZ: 'TZA',
  TH: 'THA',
  TL: 'TLS',
  TG: 'TGO',
  TK: 'TKL',
  TO: 'TON',
  TT: 'TTO',
  TN: 'TUN',
  TR: 'TUR',
  TM: 'TKM',
  TC: 'TCA',
  TV: 'TUV',
  UG: 'UGA',
  UA: 'UKR',
  AE: 'ARE',
  GB: 'GBR',
  UM: 'UMI',
  US: 'USA',
  UY: 'URY',
  UZ: 'UZB',
  VU: 'VUT',
  VE: 'VEN',
  VN: 'VNM',
  VG: 'VGB',
  VI: 'VIR',
  WF: 'WLF',
  EH: 'ESH',
  YE: 'YEM',
  ZM: 'ZMB',
  ZW: 'ZWE',
  AX: 'ALA',
}

export const country_convert_reverse = Object.fromEntries(
  Object.entries(country_convert).map(([key, value]) => [value, key]),
)

let globalMapRef: any = null

// Import country names from constants
import { countryCodes } from '@/lib/constants/countries'

const getCountryName = (code: string): string => {
  if (!code || code === 'Unknown') return 'Unknown'
  return countryCodes[code.toUpperCase()] || code
}

export const getCountryEmoji = (code: string) => {
  if (code === 'World') {
    return 'WW'
  }

  if (!code) {
    return 'NA'
  }

  if (code.length !== 2 && code.length === 3) {
    const codes = reverseObject(country_convert)
    code = codes[code]
  }

  const countryCode = code.toUpperCase()
  if (countryCode.length < 2) {
    return 'NA'
  }

  return countryCode.slice(0, 2)
}

/**
 * This function uses metric location data to draw a leaflet map
 * @param data - Location data
 * @param mode - Theme mode (dark/light)
 * @param onHoverChange - Callback for when hover state changes
 */
const initializeTopLocationsMap = async (data: any, mode: any, onHoverChange?: (country: { name: string; count: string }) => void) => {
  let L: any
  try {
    const leaflet = await import('leaflet')
    L = leaflet.default || leaflet
  } catch {
    // Optional map visualization — a failed module load must not become an
    // unhandled rejection (Safari: "Importing a module script failed").
    return
  }

  // Data for the countries
  const countryDataRaw = data?.aggregate?.filter((row: any) => {
    return row.country_aggregate && row.country
  })

  const highestAmount = countryDataRaw.reduce((prevVal: any, curVal: any) => {
    if (curVal.count > prevVal) return curVal.count
    return prevVal
  }, 1)

  const countryData = countryDataRaw.map((row: any) => {
    return {
      name: country_convert[row.country],
      count: row.count,
      normalized: Math.round((100 * row.count) / highestAmount),
    }
  })

  // Fetch the geoJSON data for world countries
  const worldCountriesGeo = await fetch(
    'https://raw.githubusercontent.com/johan/world.geo.json/master/countries.geo.json',
  )
  const worldCountriesGeoJSON = await worldCountriesGeo.json()
  worldCountriesGeoJSON.features = worldCountriesGeoJSON.features.filter(
    (country: any) => {
      return country.id !== 'ATA'
    },
  )

  if (globalMapRef) {
    globalMapRef.remove()
  }

  // Create the Leaflet map
  const map = L.map('topLocationsMap', { zoomControl: false }).setView(
    [20, 0],
    0,
  )
  globalMapRef = map

  // Function to style countries based on the count data
  function styleCountry(feature: any) {
    const country = countryData.find(
      (country: any) => country.name === feature.id,
    )
    const fillC =
      mode === 'dark' ? 'rgba(0, 0, 0, 1)' : 'rgba(255, 255, 255, 1)'
    return {
      fillColor: country ? getColor(country.normalized) : fillC,
      weight: 1,
      opacity: 1,
      color: 'rgba(40, 40, 40, 0.8)',
      fillOpacity: 1,
    }
  }

  // Function to get color based on count value
  function getColor(coeff: any) {
    // Map coeff to a value between 0 and 1
    const alpha = coeff / 100

    const color =
      mode === 'dark'
        ? `rgba(255, 255, 255, ${alpha})`
        : `rgba(0, 0, 0, ${alpha})`

    // Use alpha as the opacity in the RGBA color model
    return color
  }

  // Add the countries to the map with styling and tooltips
  L.geoJSON(worldCountriesGeoJSON, {
    style: styleCountry,
    onEachFeature: function (feature: any, layer: any) {
      let totalCount = 0
      countryData.forEach((country: any) => {
        totalCount += Number(country.count)
      })
      const worldCountry = { name: 'World', count: totalCount.toString() }
      onHoverChange?.(worldCountry)

      const country = countryData.find(
        (country: any) => country.name === feature.id,
      )

      layer.on('mouseout', function () {
        onHoverChange?.(worldCountry)
      })

      if (country) {
        layer.on('mouseover', function () {
          onHoverChange?.(country)
        })

        layer.bindTooltip(
          `<strong>${country.name}</strong><br>Count: ${country.count}`,
        )
      } else {
        layer.on('mouseover', function () {
          onHoverChange?.(worldCountry)
        })
      }
    },
  }).addTo(map)
}
